import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserStar = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 48 47",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		clipPath: "url(#prefix__clip0_2_802)",
		children: /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#prefix__clip1_2_802)",
			fill: "#3C527D",
			children: [/* @__PURE__ */ _jsx("path", { d: "M24.86 33.753a2.237 2.237 0 011.816-1.53l5.567-.81.684-1.386C29.85 29.25 25.904 28.66 21 28.66c-8.338 0-13.925 1.702-17.143 3.13A5.241 5.241 0 00.75 36.586v7.825c0 .414.336.75.75.75h27.07l.888-5.174-4.028-3.926a2.238 2.238 0 01-.57-2.308z" }), /* @__PURE__ */ _jsx("path", { d: "M46.608 33.708l-6.347-.923-2.838-5.75c-.253-.514-1.093-.514-1.346 0l-2.838 5.75-6.347.923a.75.75 0 00-.415 1.278l4.593 4.477-1.085 6.322a.75.75 0 001.088.79l5.677-2.985 5.677 2.985a.75.75 0 001.089-.79l-1.085-6.323 4.593-4.476a.75.75 0 00-.416-1.278zM21 24.16c6.439 0 11.25-6.73 11.25-12.75C32.25 5.209 27.203.16 21 .16S9.75 5.209 9.75 11.41c0 6.02 4.811 12.75 11.25 12.75z" })]
		})
	})
});
export default SvgUserStar;
